import React, { useEffect } from 'react';
import MaskedInput from 'react-text-mask';
import Image from './Image';
import './styles.css';

function useData(remoteStates, sharedStates, commands) {
  useEffect(() => {
    if (
        remoteStates.user?.imagesPaths[remoteStates.user?.imagesPaths.length - 1] === sharedStates.user.data.img
        && remoteStates.user?.email === sharedStates.user.data.email
        && remoteStates.user?.cpf === sharedStates.user.data.cpf
        && remoteStates.user?.firstName === sharedStates.user.data.firstName
        && remoteStates.user?.lastName === sharedStates.user.data.lastName
        && remoteStates.user?.whatsapp === sharedStates.user.data.whatsapp
        && remoteStates.user?.userName === sharedStates.user.data.nickname) commands.edit.finishEdit();
    else commands.edit.startEdit();
  }, [
    sharedStates.user.data.email,
    sharedStates.user.data.cpf,
    sharedStates.user.data.firstName,
    sharedStates.user.data.lastName,
    sharedStates.user.data.whatsapp,
    sharedStates.user.data.nickname,
    sharedStates.user.data.img,
  ]);

  const handleChangeFirstName = (e) => commands.user.changeUserData('firstName', e.target.value);

  const handleChangeLastName = (e) => commands.user.changeUserData('lastName', e.target.value);

  const handleChangeEmail = (e) => commands.user.changeUserData('email', e.target.value.toLowerCase().trim());

  const handleChangeWhatsapp = (e) => {
    const cleaned = (`${e.target.value}`).replace(/\D/g, '');
    commands.user.changeUserData('whatsapp', `+55${cleaned}`);
  };

  const handleChangeCPF = (e) => {
    const cleaned = (`${e.target.value}`).replace(/\D/g, '');
    commands.user.changeUserData('cpf', cleaned);
  };

  const handleChangeNickname = (e) => commands.user.changeUserData('nickname', e.target.value.toLowerCase().trim());

  return ({
    localStates: {

    },
    eventHandlers: {
      handleChangeWhatsapp,
      handleChangeCPF,
      handleChangeFirstName,
      handleChangeLastName,
      handleChangeNickname,
      handleChangeEmail,
    },
  });
}

export default function Data(props) {
  const {
    remoteStates, metaStates, commands, sharedStates,
  } = props;
  const { eventHandlers } = useData(remoteStates, sharedStates, commands);

  if (metaStates?.isLoading || metaStates?.isIdle) return null;

  return (
    <section className="data-container">
      <div className="image-and-nickname-container">
        <Image
          sharedStates={sharedStates.user}
          remoteStates={remoteStates}
          commands={commands.edit}
        />
        <p>@</p>
        <div className="floating-label-input">
          <input placeholder="Apelido" id="nickname" type="text" name="nickname" value={sharedStates.user.data.nickname || ''} onChange={eventHandlers.handleChangeNickname} />
          <label htmlFor="nickname">Apelido</label>
        </div>
      </div>
      <div className="floating-label-input">
        <input placeholder="E-mail" id="email" type="e-mail" name="email" value={sharedStates.user.data.email || ''} onChange={eventHandlers.handleChangeEmail} />
        <label htmlFor="email">E-mail</label>
      </div>
      <div className="floating-label-input">
        <input placeholder="Primeiro nome" id="firstName" type="text" name="firstName" value={sharedStates.user.data.firstName || ''} onChange={eventHandlers.handleChangeFirstName} />
        <label htmlFor="firstName">Primeiro nome</label>
      </div>

      <div className="floating-label-input">
        <input placeholder="Último nome" id="lastName" type="text" name="lastName" value={sharedStates.user.data.lastName || ''} onChange={eventHandlers.handleChangeLastName} />
        <label htmlFor="lastName">Último nome</label>
      </div>

      <div className="floating-label-input">
        <MaskedInput
          value={sharedStates?.user?.data?.whatsapp?.substring(3,14) || ''}
          onChange={eventHandlers.handleChangeWhatsapp}
          mask={['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
          placeholder="Whatsapp"
          id="whatsapp"
          type="text"
          name="whatsapp"
        />
        {/* <input required placeholder="Whatsapp" id="whatsapp" type="text" name="whatsapp" value={formatPhoneNumber(whatsapp)} onChange={(e) => setWhatsapp(e.target.value)} /> */}
        <label htmlFor="whatsapp">Whatsapp</label>
      </div>

      <div className="floating-label-input">
        <MaskedInput
          value={sharedStates.user.data.cpf || ''}
          onChange={eventHandlers.handleChangeCPF}
          mask={[/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
          placeholder="CPF"
          id="cpf"
          type="text"
          name="cpf"
        />
        <label htmlFor="cpf">cpf</label>
      </div>
    </section>
  );
}
